import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ResultValueTable.styled';
import { resultItem } from '../../../proptypes/Actions';
import WrapResultValue from '../../atoms/WrapResultValue/WrapResultValue';
import PreviewModal from '../PreviewModal/PreviewModal';
import OpenModalTextButton from '../../atoms/OpenModalTextButton/OpenModalTextButton';
import ValueTable from '../ValueTable/ValueTable';
import LargeHeading from '../../atoms/LargeHeading/LargeHeading';

const ResultValueTable = (props) => {
  const [visible, setVisible] = useState(false);

  const handleOpen = useCallback(() => {
    setVisible(true);
    console.log('test open');
  }, []);
  const handleClose = useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <>
      <WrapResultValue centered={true} title={props.resultItem.title}>
        <OpenModalTextButton onClick={handleOpen}>
          View Results
        </OpenModalTextButton>
      </WrapResultValue>
      <PreviewModal show={visible} onHide={handleClose}>
        <Styled.Wrapper>
          <LargeHeading>{props.resultItem.title}</LargeHeading>
          <ValueTable resultItem={props.resultItem} />
        </Styled.Wrapper>
      </PreviewModal>
    </>
  );
};

ResultValueTable.propTypes = {
  resultItem: resultItem,
};

export default ResultValueTable;
